import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function RegisterSuccess() {
  return (
    <div className='register-form__success' data-cy='register.sucess'>
      <FontAwesomeIcon icon='check-circle' color='green' size='5x' style={{ display: 'block', margin: 'auto' }} />
      <h4 className='mt-5 mb-3 text-center'>Tak. Din anmodning er nu sendt</h4>
      <p className='text-center'>Før du kan logge ind skal en administrator godkende din bruger. Du modtager en email når dette er sket.</p>
    </div>
  )
}
